module.exports = __webpack_public_path__ + "img/164.2597031a.jpg";